import React,{useState,useRef,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL } from '../../services/redirect'
import { ValidateForm } from '../../validations/schemaBanners'
import { DropdownComponent } from '../../components/options'
import DropzoneSingleImage from '../../components/dropzone-single-image'
import AuthDenied from '../ErrorPage/denied'


export default function EditBannerComponent(props){

  const params = useParams();


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [submitSpinner,setSubmitSpinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }



  /*----------------------------------------
    Handle Form Submit
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [state, setState] = useState({
    id:'',
    name:'',
    status:'1',
    file:'',
    file_name:'',
    file_url:'',
  });

  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setSubmitSpinner(true);

    let formData = new FormData();
    formData.append('type','update');
    formData.append('info',JSON.stringify(values));
    formData.append('file',values.file);
    axios.post('/admin/banners/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setSubmitSpinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
          if(buttonclick==1){
            WindowLocation('/banners/list');
          }else{
            WindowReload();
          }
        },2000);
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },2000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },2000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });


  }

  /*------------------------------------------------------
          Banner Details
  -------------------------------------------------------*/
  const [dropZone,setdropZone] = useState(false);
  function DataDetails(id){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','details');
    formData.append('id',id);
    axios.post('/admin/banners/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj==0){
        WindowLocation('/banners/list');
        return false;
      }

      setState({
        ...state,
        id:obj.id,
        name:obj.name,
        status:obj.status,
        file:obj.file,
        file_name:obj.file_name,
        file_url:obj.file_url,
      });

      setdropZone(true);


    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
  }

  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [statusOptions, setStatusOptions] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setStatusOptions(source.status);
  }



  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('gc6vsynfb4hxjarq7');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){
            if(params.id){
              DataDetails(params.id);
            }else{
              WindowLocation('/banners/list');
              return false;
            }
        }
        setloader(false);
        setspinner(false);

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
    HandleOptions();
  },[]);

  return (
    <React.Fragment>

      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {submitSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

      {((authPages['view']==0||authPages['editing']==0)&&!spinner)&&<AuthDenied/>}
      {(authPages['view']==1&&!spinner)&&<React.Fragment>

      <div className="page-wrapper-half">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>Update Banner</h1></div>
            <div>
            <Button className='LightGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
            <Button className='GreenButton strong' size='tiny' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/banners/list')}/>
            </div>
          </div>
       </div>
      <div className="app-body-wrapper">
      <Form>
        <Formik
            enableReinitialize
            initialValues={state}
            validationSchema={ValidateForm}
            onSubmit={handleSubmitForm}
            render={formProps => {
            const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

            function SetFileImage(file){
              setFieldValue('file',file);
            }
            function SetFilePath(file){
            }

            return(
                    <div className="page-form-panel">
                        <div className="page-form-body">
                        <div class="alert-message left error">
                            <div><i class="info circle icon"></i></div>
                            <div><p>All fields are required.</p></div>
                        </div>
                        <br/>


                        <Form.Group widths="equal">
                           <Field name="name">
                               {({ field, form }) => (
                               <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                 <label>Title</label>
                                 <Input {...field} onChange={handleChange}/>
                                 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                               </Form.Field>
                               )}
                         </Field>
                       </Form.Group>

                      <Form.Group widths="equal">
                         <Field name="status">
                           {({ field, form }) => (
                               <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                 <label>Status</label>
                                 <Select selectOnBlur={false}
                                     {...field}
                                     options={statusOptions}
                                     onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                               </Form.Field>
                           )}
                         </Field>
                       </Form.Group>


                       <Form.Group widths="equal">
                         <Field name="file">
                             {({ field, form }) => (
                             <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                               <label>Image</label>
                               {dropZone&&<DropzoneSingleImage mockdata={state} data={SetFileImage} path={SetFilePath}/>}
                               { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                             </Form.Field>
                             )}
                         </Field>
                       </Form.Group>



                        </div>{/*.page-form-body*/}

                        <div className="page-form-footer">
                            <Button disabled={spinner||authPages['editing']==0} className='LightGrayButton strong' size='small' content='Save and back to list' icon='save icon' onClick={() => buttonSubmit(1)}/>
                            <Button disabled={spinner||authPages['editing']==0} className='PrimaryButton strong' size='small' content='Save and stay on page' icon='save icon' onClick={() => buttonSubmit(2)}/>
                            <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                        </div>

                 </div>

            )}}/>
          </Form>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}
